import EntityListCombined from './EntityListCombined';
import EntityListTimeSeries from './EntityListTimeSeries';
import { entityListSpec, hashtagListSpec } from './entityListModel';
import type { VisualProps } from '../types';

/** Bound here, not in `visuals/index.ts`: that module is `.ts` and holds no JSX. */
export const PopIndexListCombined = (props: VisualProps) => (
    <EntityListCombined {...props} spec={entityListSpec(props.input)} />
);

export const PopIndexListTrendLines = (props: VisualProps) => (
    <EntityListTimeSeries {...props} spec={entityListSpec(props.input)} />
);

export const HashtagListCombined = (props: VisualProps) => (
    <EntityListCombined {...props} spec={hashtagListSpec} />
);

export const HashtagListTrendLines = (props: VisualProps) => (
    <EntityListTimeSeries {...props} spec={hashtagListSpec} />
);
